var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-row",
    [
      _c("b-col", [
        _c(
          "div",
          { staticClass: "club-group" },
          _vm._l(_vm.orderTypeIds, function (tid) {
            return _c(
              "div",
              {
                key: tid,
                staticClass: "club-card",
                class: {
                  selected: _vm.selectedOrderTypeComputed === tid,
                  duplicate: _vm.hasDuplicates(tid),
                },
                on: {
                  click: function ($event) {
                    _vm.selectedOrderTypeComputed = tid
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "club-card-inner" },
                  [
                    _c("AImage", {
                      staticClass: "club-card-image",
                      attrs: {
                        img: _vm.orderTypes[tid].image,
                        preset: "wineclubteaser",
                        responsive: "",
                        contain: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "club-card-content" }, [
                      _c("div", { staticClass: "title" }, [
                        _c("h3", [_vm._v(_vm._s(_vm.orderTypes[tid].title))]),
                      ]),
                      _vm._v(" "),
                      !_vm.hasDuplicates(tid)
                        ? _c("div", {
                            staticClass: "description",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.formatedHtml(_vm.orderTypes[tid].abstract)
                              ),
                            },
                          })
                        : _c("div", { staticClass: "duplicate-error" }, [
                            _c("strong", [_vm._v("WARNING:")]),
                            _vm._v(
                              " This cannot be used as " +
                                _vm._s(_vm.numDuplicates(tid)) +
                                " entries exist. Please contact the admin.\n            "
                            ),
                          ]),
                    ]),
                  ],
                  1
                ),
              ]
            )
          }),
          0
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }